/**
 * HomeCTA — 비로그인 홈 화면 하단 CTA 바
 *
 * 챗봇이 처음 열렸을 때(인사 메시지만 있을 때) 입력창 위에 노출되어
 * 사용자가 첫 행동을 시작하도록 유도한다. 첫 메시지 이후에는 자동으로 사라진다.
 *
 * 컴팩트 칩 형태로 flex-wrap. 5개 버튼이 2~3줄에 자연스럽게 나열된다.
 */

import { cn } from '@/lib/utils';
import type { CTAButton } from '@/types/qa';

interface HomeCTAProps {
  buttons: CTAButton[];
  onAction: (button: CTAButton) => void;
}

export function HomeCTA({ buttons, onAction }: HomeCTAProps) {
  return (
    <div
      className={cn(
        'ml-flex ml-flex-col ml-gap-2',
        'ml-px-3.5 ml-py-3 ml-flex-shrink-0',
        'ml-bg-surface ml-border-t ml-border-line-soft'
      )}
    >
      <div
        className={cn(
          'ml-text-cb-xs ml-font-semibold ml-text-mute',
          'ml-tracking-wider ml-uppercase'
        )}
      >
        시작해 보세요
      </div>
      <div className="ml-flex ml-flex-wrap ml-gap-1.5">
        {buttons.map((btn) => (
          <CTAButtonItem key={btn.id} button={btn} onClick={() => onAction(btn)} />
        ))}
      </div>
    </div>
  );
}

interface CTAButtonItemProps {
  button: CTAButton;
  onClick: () => void;
}

function CTAButtonItem({ button, onClick }: CTAButtonItemProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'ml-px-3.5 ml-py-2',
        'ml-rounded-cb-md ml-border ml-cursor-pointer',
        'ml-text-cb-base ml-font-medium ml-whitespace-nowrap',
        'ml-shadow-sm',
        'ml-transition-all ml-duration-150',
        button.highlight
          ? 'ml-bg-brand-600 ml-border-brand-700 ml-text-white hover:ml-bg-brand-500'
          : cn(
              'ml-bg-white ml-border-line ml-text-ink-secondary',
              'hover:ml-border-brand-600 hover:ml-bg-brand-50 hover:ml-text-brand-600',
              'active:ml-translate-y-px active:ml-shadow-none'
            )
      )}
    >
      {button.label}
    </button>
  );
}
